<script lang="ts">import { t } from "@infinitro/content";
import { isMobile, loggedIn, toSiteUrl } from "@infinitro/global";
import { RemoteIcon } from "@infinitro/icons";
import { InfoCard } from "@infinitro/info-card";
import { Text } from "@infinitro/text";
export let title;
export let icon;
export let borderColor;
export let backgroundImage;
export let linkUrl;
$: href = toSiteUrl(linkUrl, $loggedIn);
</script>

<!-- eslint-disable-next-line svelte/no-navigation-without-resolve -- dynamic site URL from toSiteUrl -->
<a class="promo-card-link" {href} data-sveltekit-preload-data="off">
	<InfoCard
		noPadding
		borderRadius={$isMobile ? '22px' : '28px'}
		customStylesCardContent="z-index: 1; overflow: hidden; border-radius: inherit;"
		radialGradient2BeforeTopColor={borderColor}
	>
		<div class="promo-card-box">
			<div class="promo-card">
				<div class="promo-card-banner">
					<img src={backgroundImage} alt={$t(title)} class="promo-card-image" />
				</div>
				<div class="promo-card-footer">
					<span class="promo-card-footer-icon">
						<RemoteIcon {icon} size={22} />
					</span>
					<Text bodyWeight="bold" bodySize={$isMobile ? 'large' : 'medium'}>
						{$t(title)}
					</Text>
				</div>
			</div>
		</div>
	</InfoCard>
</a>

<style>
	.promo-card-link {
		display: block;
		width: 100%;
		flex: 1 1 0%;
}

	.promo-card-box {
		position: relative;
		width: 100%;
		min-height: 163px;
}

	.promo-card {
		position: absolute;
		inset: 0px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
}

	.promo-card-banner {
		position: relative;
		display: flex;
		height: 70%;
		width: 100%;
		justify-content: center;
		overflow: hidden;
}

	.promo-card-image {
		position: absolute;
		left: 0px;
		top: 0px;
		min-height: 100%;
		width: 100%;
		-o-object-fit: fill;
		   object-fit: fill;
		-o-object-position: right center;
		   object-position: right center;
}

	.promo-card-footer {
		display: flex;
		height: 30%;
		align-items: center;
		justify-content: flex-start;
		gap: 0.5rem;
		padding-left: 0.75rem;
		padding-right: 0.75rem;
		padding-top: 0.25rem;
		padding-bottom: 0.25rem;
}

	.promo-card-footer-icon {
		display: flex;
		flex-shrink: 0;
		align-items: center;
		justify-content: center;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		width: 22px;
		height: 22px;
}

	@media (min-width: 768px) {
		.promo-card-box {
			min-height: 240px;
		}
	}

	@media (min-width: 1024px) {
		.promo-card-box {
			min-height: 240px;
		}

		.promo-card-banner {
				height: 80%;
				max-height: 80%;
		}

		.promo-card-footer {
				height: 20%;
				padding-top: 0px;
				padding-bottom: 0px;
		}
	}
</style>
